export default __webpack_public_path__ + "cache-tile-fetching-scheme-1200-29c0cd262d8037e051c7aeabe3d70869.png";